import type React from 'react';

import { setClass } from '../../helpers/utils';
import './styles.scss';

type ChipProps = {
	variant?: 'neutral' | 'success' | 'warning' | 'danger';
	className?: string;
	title?: string;
	shape?: string;
	children?: React.ReactNode;
	iconClose?: boolean;
};

export const Chip = ({
	variant = 'neutral',
	className = '',
	title = '',
	shape = '',
	children,
	iconClose,
}: ChipProps) => {
	const typeVariant = {
		neutral: 'is-neutral',
		success: 'is-success',
		warning: 'is-warning',
		danger: 'is-danger',
	};

	const typeShape = {
		disc: 'is-disc',
	};

	const isVariant = typeVariant[variant] || '';
	const isShape = typeShape[shape] || '';

	return (
		<code
			className={setClass(
				`chip ${isVariant} ${isShape} ${className} ${iconClose ? 'with-icon-close' : ''}`,
			)}
			title={title}
		>
			{children}
		</code>
	);
};
